<template>
  <div class="homepage">
    <!--la key rimonta l'hero al cambio tab: rilegge le slide del provider e re-inizializza lo swiper-->
    <hero :key="package_type" :slider-variant="slider_variant" />

    <!--booking engine-->
    <section class="section section--booking-engine">
      <b-container v-if="is_authenticated()">
        <booking-engine
          @search="
            () => {
              this.$router.push({ name: 'results' });
            }
          "
        />
      </b-container>
    </section>

    <section v-if="searching" class="section section--loader">
      <loader size="large" :show_timing_slot="true" />
    </section>

    <!--brands-->
    <section class="section">
      <b-container>
        <brands />
      </b-container>
    </section>

    <!--static content section-->
    <section class="section">
      <b-container>
        <b-row>
          <b-col
            v-for="(block, block_index) in static_blocks"
            :key="block_index"
            lg="6"
          >
            <div class="section--booking-engine static">
              <div class="section--booking-engine__backdrop">
                <img :src="block.image" alt />
              </div>
              <div class="section--booking-engine__content">
                <b-container fluid>
                  <vb-icon :name="'symbol_vv'" />
                  <div class="d-flex flex-column align-items-start">
                    <div class="section--booking-engine__heading">
                      <h2
                        class="vb-heading d-inline-block"
                        v-html="block.heading"
                      ></h2>
                    </div>
                    <div
                      v-for="(text, text_index) in block.texts"
                      :key="text_index"
                      class="section--booking-engine__text mb-2"
                      :class="{ hidden: text.hidden }"
                      v-html="text.value"
                    ></div>
                  </div>
                </b-container>
              </div>
            </div>
            <p class="text mt-4" v-html="block.caption"></p>
          </b-col>
        </b-row>
      </b-container>
    </section>

    <!--suggestions section-->
    <section
      v-if="suggestions.length && is_flight_and_stay_package"
      class="section"
    >
      <b-container>
        <suggestions
          :suggestions="suggestions"
          :autoplay="suggestions_autoplay_speed"
        />
      </b-container>
    </section>

    <!--live booking e flyby-->
    <div class="section">
      <b-container>
        <div class="d-flex justify-content-center">
          <vb-icon class="mr-3" :name="'symbol_vv'" />
          <h3 class="vb-heading" v-html="'Cerchi solamente un volo?'"></h3>
        </div>
        <div class="d-flex justify-content-center mt-5">
          <a
            href="https://voli.vadobay.com/"
            target="_blank"
          ><img
            class="px-4"
            src="assets/images/common/brands/fly-by-payoff.svg"
            alt="VadoBay fly by"
          /></a>
        </div>
        <p
          class="text-center mt-5"
        >
          Cerca il nostro servizio <strong>fly by VadoBay</strong> sul tuo
          portale welfare.
        </p>
      </b-container>
    </div>

    <!--value props list-->
    <section class="section">
      <b-container>
        <point-list-01
          :pl="[
            {
              pl_icon: 'shield',
              pl_title: 'I migliori brand italiani',
              pl_text:
                'Alpitour, Francorosso, Bravo, Edenviaggi e tanti altri. Il meglio delle vacanze in tutto il mondo.',
            },
            {
              pl_icon: 'happy_pin',
              pl_title: 'Per il welfare aziendale',
              pl_text:
                'Un servizio pensato per un\'utenza aziendale, dal booking online all\'assistenza',
            },
            {
              pl_icon: 'hands',
              pl_title: 'Conferma immediata',
              pl_text:
                'Nessuna burocrazia, nessun rimborso e nessun voucher. Prenoti con un click!',
            },
            {
              pl_icon: 'heart',
              pl_title: 'Come in agenzia ma online',
              pl_text: `Solo su ${get_config('site.brand', '')} ${get_config('site.payoff', '')} trovi un\'assistenza attenta e dedicata anche su webchat e WhatsApp`,
            },
          ]"
        />
      </b-container>
    </section>

    <!--welfare non sufficiente-->
    <section
      v-if="is_authenticated() && get_config('integration.welfare')"
      class="section"
    >
      <image-with-text-cta
        :image_src="'assets/images/alpitour/statics/iStock-1180231917.png'"
        :text_heading="'Welfare non sufficiente?'"
        :text_content="'Se il tuo credito welfare non è sufficiente troviamo insieme una soluzione.'"
        :text_cta="[
          {
            cta_text: `Contattaci`,
            cta_icon: 'phone',
            cta_url: `phone:${get_config('site.phoneNumber', '')}`,
          },
          /*
          {
            cta_text: 'Chat',
            cta_icon: 'chat',
            cta_action: 'support',
            cta_id: 'alpitour-homepage-welfare-chat',
          },
          {
            cta_text: 'Whatsapp',
            cta_icon: 'whatsapp',
            cta_url: get_config('site.waIntentLink', ''),
          },
          {
            cta_text: 'Email',
            cta_icon: 'email',
            cta_url: 'mailto:'+get_config('site.emailSupport', ''),
          }*/
        ]"
      />
    </section>

    <!--value props row-->
    <section class="section">
      <b-container>
        <value-proposition
          :vp="[
            {
              vp_image: 'assets/images/alpitour/statics/iStock-1208856002.jpg',
              vp_content: [
                {
                  vp_icon: 'symbol_vv',
                  vp_title: 'Hai bisogno di un consiglio?',
                  vp_text:
                    'Se cerchi un suggerimento o la soluzione a tue specifiche esigenze, parla con un nostro consulente. <strong><a href=' +
                    get_config('site.phoneNumber', '') +
                    '>Chiamaci allo ' +
                    get_config('site.phoneNumber', '') +
                    '</a></strong>',
                },
                {
                  vp_icon: 'symbol_vv',
                  vp_title: 'Su di noi puoi contare!',
                  vp_text:
                    'Solo Vacanze VadoBay ti offre un\'assistenza multicanale, telefonica, webchat, WhatsApp, email, webcall a portata di click e dedicata a gli utenti di welfare aziendale. ',
                  vp_support_action: 'Parla con noi!',
                  vp_cta_id: 'alpitour-homepage-vp-multichannel',
                },
              ],
            },
          ]"
        />
      </b-container>
    </section>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex"
import Hero from '@components/blocks/hero.vue'
import PointList01 from '@library/blocks/point-list-01.vue'
import ValueProposition from '@library/blocks/value-proposition.vue'
import Suggestions from '@alpitour/components/blocks/suggestions.vue'
import Brands from '@alpitour/components/blocks/brands.vue'
import ImageWithTextCta from '@library/blocks//image-with-text-cta.vue'
import { get_config } from "@src/utilities"
import { PACKAGE_TYPE_PROVIDER } from "@alpitour/resources"
import { STATIC_BLOCKS } from "./logic"

export default {
  name: 'homepage',
  components: {
    'hero': Hero,
    'point-list-01': PointList01,
    'value-proposition': ValueProposition,
    'brands': Brands,
    'suggestions': Suggestions,
    'image-with-text-cta': ImageWithTextCta
  },
  data() {
    return {
      suggestions: get_config('searchSuggestions'),
      suggestions_autoplay_speed: get_config('guiSettings.autoplaySpeedSuggestions', 0),
    }
  },
  computed: {
    // global state keys
    ...mapState([
      'searching',
    ]),
    ...mapGetters(
      "liveat", ["is_flight_and_stay_package"]
    ),
    // module state keys
    ...mapState("liveat", [
      'package_type',
    ]),
    static_blocks() {
      return STATIC_BLOCKS[this.package_type]
    },
    slider_variant() {
      return PACKAGE_TYPE_PROVIDER[this.package_type]
    },
  },
};
</script>

<style lang="scss" scoped>
  .section {
    z-index: 100;

    &--booking-engine {
      position: relative;

      & + .text {
        font-size: 0.8125rem;
      }

      .container,
      .container-fluid {
        position: relative;
        z-index: 90;
      }

      &__backdrop {
        position: absolute;
        width: 100%;
        height: 100%;
        overflow: hidden;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;

        &::before {
          content: '';
          position: absolute;
          width: 100%;
          height: 100%;
          background: $black;
          z-index: 10;
          opacity: 0.05;
        }

        img {
          position: absolute;
          width: 100%;
          height: 100%;
          object-fit: cover;
          object-position: center center;
        }
      }

      &__content {
        display: block;
        width: 100%;

        .container,
        .container-fluid {
          display: flex;
          align-items: flex-start;

          & > .vb-icon {
            margin-top: 8px;
            margin-right: 10px;
          }
        }
      }

      &__heading {
        display: block;

        .vb-heading {
          background: $white;
          padding: 0 8px 0 12px;
          border-radius: $border-radius;
        }
      }

      &__text {
        display: inline-block;
        background: $white;
        padding: 0 8px 0 12px;
        border-radius: $border-radius;
        font-size: 1.25rem;
      }

      &.static {
        height: auto;
        padding: 0;

        .section--booking-engine__backdrop {
          border-radius: $border-radius-lg;
          position: static;

          img {
            position: static;
          }
        }

        .section--booking-engine__content {
          position: absolute;
          width: 100%;
          height: 100%;
          top: 0;
          display: flex;
          align-items: flex-end;
          padding-bottom: $grid-gutter-width * 2;

          .hidden {
            visibility: hidden;
          }

          .container-fluid {
            @include media-breakpoint-down(md) {
              .hidden {
                display: none;
              }
            }
          }
        }
      }

      .booking-engine {
        @include media-breakpoint-up(md) {
          margin-top: -140px;
        }
      }
    }
  }

  ::v-deep {
    .image-with-text-cta {
      background: $white;

      &__image img {
        object-position: center 20%;
        width: 1600px;
        right: 0;
        left: 0;
        margin: 0 auto;
      }
    }

    .hero--slider-item {
      &:after {
        background-color: $primary;
      }
      .vb-heading,
      .text {
        @include media-breakpoint-up(md) {
          color: $white !important;
        }
      }
      .captions {
        .vb-icon {
          display: none;
        }
      }
    }
  }
</style>
